import Prism from "prismjs";
import "prism-theme-night-owl";

Prism.highlightAll();

const sidebarLinkItems = document.querySelectorAll(".demo-sidebar .c-link");

const handleClick = e => {
  const active = document.querySelector(".c-link--active");
  if (active) {
    active.classList.remove("c-link--active");
  }
  e.currentTarget.classList.add("c-link--active");
};

sidebarLinkItems.forEach(item => {
  item.addEventListener("click", handleClick);
});

window.dataLayer = window.dataLayer || [];

function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", "UA-140452156-1");
